import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    this.inputTarget.value == 'reload' ? location.reload(true) : this.inputTarget.value = 'reload'
  }
}
